import { CalendarToday } from "@mui/icons-material";
import moment from "moment";

export const AddCalendarForDatePicker = (
  value: any,
  ref: any,
  style?: any,
  iconStyle?: any,
  disabled: boolean = false
) => {
  const defaultStyle = {
    width: 220,
    height: 23,
    cursor: "pointer",
    textAlign: "center",
    border: "1px solid #333",
  };
  const defaultIconStyle = {
    position: "absolute",
    top: 3,
    right: 4,
  };
  // console.log(value);
  return (
    <div
      style={{ position: "relative" }}
      ref={ref}
    >
      <input
        value={(value as Date[])?.map((d: any) => moment(d).format("MM/DD/YYYY")).join(" to ")}
        style={style ?? defaultStyle}
        disabled={disabled}
      />
      <div
        style={{
          ...(iconStyle ?? defaultIconStyle),
          pointerEvents: disabled ? "none" : "auto",
        }}
      >
        <CalendarToday style={{ fontSize: 14 }} />
      </div>
    </div>
  );
};
